import React from 'react'

function CostCategory() {
  return (
    <div>CostCategory</div>
  )
}

export default CostCategory